export default __webpack_public_path__ + "static/media/panel-bg.d30f8fee.webp";